<template>
  <iframe src="https://prozesskostenrechner-dmb.dahag-web.de/"
          width="100%"
          height="1930"
          style="border:none;margin-top:16px;" />
</template>
<script>
export default {
  name: "ProzesskostenrechnerPage",
  computed: {}
};

</script>
<style>

</style>
